import { useState } from "react";
import { collection, setDoc, doc } from "firebase/firestore";
import { db } from "../../../firebase/config";

export default function LeagueForm() {
  const [formData, setFormData] = useState({
    fullName: "",
    description: "",
    creator: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const id = formData.fullName.toLowerCase().replace(/\s+/g, "-");
    await setDoc(doc(db, "leagues", id), {
      ...formData,
      athletesArray: [],
    });
    alert("League added!");
    setFormData({ fullName: "", description: "", creator: "" });
  };

  return (
    <form className="admin-form" onSubmit={handleSubmit}>
      <input
        name="fullName"
        placeholder="League Name"
        value={formData.fullName}
        onChange={handleChange}
        required
      />
      <textarea
        name="description"
        placeholder="Description"
        value={formData.description}
        onChange={handleChange}
        required
      />
      <input
        name="creator"
        placeholder="Creator Email"
        value={formData.creator}
        onChange={handleChange}
        required
      />
      <button type="submit">Save League</button>
    </form>
  );
}
